import classNames from 'classnames';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import Merchant from '../../../domain/entities/Merchant';
import Review from '../../../domain/entities/Review';
import ReviewComponent from './Review';
import css from './ReviewList.module.scss';
import ReviewSummary from './ReviewSummary';

interface Props {
  className?: string;
  merchant: Merchant;
  reviews: Review[];
  max?: number;
  showHeader?: boolean;
  rate_count_starby?: {
    one: number;
    two: number;
    three: number;
    four: number;
    five: number;
  };
}

const ReviewList = ({
  className,
  merchant,
  reviews,
  max,
  rate_count_starby,
}: Props & InjectedIntlProps) => {
  const classes = classNames(css.ReviewList, className);
  const rateCount = merchant.rating.totalCount;
  const rate = merchant.rating.average;
  let recentReviews = reviews;
  if (max) {
    recentReviews = reviews.slice(0, max);
  }

  if (recentReviews.length === 0) {
    return null;
  }

  return (
    <div className={classes}>
      <div>
        {rate > 0 && rateCount > 0 && rate_count_starby && (
          <ReviewSummary
            className={css.ReviewList__Summary}
            rate={rate}
            rate_count={rateCount}
            rate_count_starby={rate_count_starby}
          />
        )}
      </div>
      {
        <ul className={css.ReviewList__Body}>
          {recentReviews.map((review, i) => (
            <ReviewComponent
              className={css.ReviewList__Review}
              review={review}
              key={i}
            />
          ))}
        </ul>
      }
    </div>
  );
};

export default injectIntl(ReviewList);
